export const getStyles = (theme) => ({
    mainContainer: {
        width: "100%",
        height: 'cacl(100vh - 20px)',
        paddingBottom: '20px'
    },
    cardContainer: {
        padding: '20px 20px 0px 20px',
        marginLeft: '30px'
    },
    fileUploadContainer: {
        height: "100px",
        backgroundColor: '#FFFFFF',
        borderRadius: '5px',
        width: '500px',
        textAlign: 'center',
        cursor: 'pointer',
        border: "1px solid #D9D9D9",
        padding: '10px',
        position: "relative"
    },
    errorText: {
        fontSize: theme.typography.h6,
        fontWeight: 400,
        color: 'red'
    },
})